import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

// Couriers / hauliers / our own van. Managed on the Delivery Partners page,
// picked for each order when it's closed out in Validate Orders.
export interface DeliveryPartner {
  id?: number;
  name: string;
  phone: string;
  trackingUrl: string;
  active: boolean;
  // Orders sent with this partner (management list only).
  orders?: number;
}

@Injectable({ providedIn: 'root' })
export class DeliveryPartnersService {
  constructor(private http: HttpClient) {}

  // all: include switched-off partners (management page).
  list(all = false): Observable<DeliveryPartner[]> {
    return this.http.get<DeliveryPartner[]>(all ? '/delivery-partners?all=1' : '/delivery-partners');
  }

  create(p: DeliveryPartner): Observable<DeliveryPartner> {
    return this.http.post<DeliveryPartner>('/delivery-partners', p);
  }

  update(id: number, p: DeliveryPartner): Observable<DeliveryPartner> {
    return this.http.put<DeliveryPartner>(`/delivery-partners/${id}`, p);
  }

  remove(id: number): Observable<{ deleted: boolean; deactivated: boolean }> {
    return this.http.delete<{ deleted: boolean; deactivated: boolean }>(`/delivery-partners/${id}`);
  }

  forOrder(orderId: number): Observable<DeliveryPartner | null> {
    return this.http.get<DeliveryPartner | null>(`/delivery-partners/order/${orderId}`);
  }

  assignToOrder(orderId: number, partnerId: number): Observable<DeliveryPartner> {
    return this.http.put<DeliveryPartner>(`/delivery-partners/order/${orderId}`, { partnerId });
  }
}
